import { render, staticRenderFns } from "./miniUser.vue?vue&type=template&id=5f6ed519&scoped=true&"
import script from "./miniUser.vue?vue&type=script&lang=js&"
export * from "./miniUser.vue?vue&type=script&lang=js&"
import style0 from "./miniUser.vue?vue&type=style&index=0&id=5f6ed519&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6ed519",
  null
  
)

export default component.exports